/* eslint-disable no-unused-vars */
export enum MultipleDisplayEnum {
  DEFAULT = 'DEFAULT',
  BUBBLE = 'BUBBLE',
  CLOUD = 'CLOUD',
}

export const getBackgroundColor = (bubbleType: MultipleDisplayEnum) => {
  switch (bubbleType) {
    case MultipleDisplayEnum.BUBBLE:
      return '#ffde77';
    case MultipleDisplayEnum.CLOUD:
      return '#f2f2f2';
    case MultipleDisplayEnum.DEFAULT:
      return '#c4e5ec';
    default:
      return '#c4e5ec';
  }
};
